export const computeDurationSeconds = (
  startTime: number | null,
  { maxSeconds }: { maxSeconds?: number } = {},
): number | null => {
  if (!startTime) {
    return null;
  }
  const seconds = Math.round((Date.now() - startTime) / 1000);
  if (maxSeconds != null && (seconds < 0 || seconds > maxSeconds)) {
    return null;
  }
  return seconds;
};
